// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"753":"30c060bc","826":"30c060bc"}[chunkId] + ".chunk.css";
};